import React from "react";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { Body, BodyContent, BodyHeading } from "@thrivetribe/mvf.ui.organisms.body";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TagType } from "types";
import { ArticleListing } from "ui/molecules/ArticleListing";
import "./ArticlesPage.scss";

interface ArticlesPageProps {
  heading?: string;
  tagType?: TagType;
  tags?: string[];
}

export const ArticlesPage: React.FC<ArticlesPageProps> = ({ heading, tagType, tags }) => {
  const navigate = useNavigate();
  let { campaign } = useParams();
  let location = useLocation();

  if (location.search) {
    let searchParams = new URLSearchParams(location.search);
    heading = searchParams.get("campaign") as string;
    tagType = (searchParams.get("tagType") ?? "pillarTags") as TagType;
    tags = searchParams.getAll(tagType) ?? [campaign];
  }

  return (
    <Body className="articles">
      <>
        <Helmet>
          <title>{heading ?? "Articles"} - MAN v FAT</title>
        </Helmet>
        <BodyHeading slim>
          <Button variant="text" onClick={() => navigate(-1)}>
            <ButtonArrow />
            Back
          </Button>
          <h1>{heading ?? "Articles"}</h1>
        </BodyHeading>

        <BodyContent>
          <ArticleListing tagType={tagType} tags={tags ?? undefined} />
        </BodyContent>
      </>
    </Body>
  );
};
